import React from 'react';
import { useBrokerDetailsStore, FormField } from '../../../state/brokerDetailsStore';
import { useBrokerFieldFieldChanged } from '../../../hooks/useBrokerFieldChanged';
import { StateDropDown } from '@apply/components';
import { ShowIf } from '@apply/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface BusinessStateFieldProps {
    readOnly: boolean;
}

export const BusinessStateField: React.FC<BusinessStateFieldProps> = ({ readOnly = false }) => {
    const businessState = useBrokerDetailsStore((s) => s.businessState);
    const updateFields = useBrokerDetailsStore((s) => s.updateFields);
    const changed = useBrokerFieldFieldChanged(FormField.BusinessState);

    return (
        <>
            <StateDropDown
                id='businessState'
                value={businessState}
                onChange={(v) => updateFields({ businessState: v })}
                label='State of Incorporation'
                width={'100%'}
                required={true}
                readOnly={readOnly}
            />
            <ShowIf showIf={changed}>
                <FontAwesomeIcon
                    icon={'asterisk'}
                    className='required-icon'
                />
            </ShowIf>
        </>
    );
};
